import { render } from "./FirebaseError.vue?vue&type=template&id=30f200a7"
import script from "./FirebaseError.vue?vue&type=script&lang=js"
export * from "./FirebaseError.vue?vue&type=script&lang=js"

import "@/assets/styles/components/FirebaseError.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__